<div class="container">
    <h2> Add User Form </h2>
    
    <form #UserRegisterForm="ngForm" (ngSubmit)="onSubmit(UserRegisterForm)">
          <fieldset>
            <legend class="mb-0">Personal Information</legend>
            <div class='row'>
                
                <div class='col-sm-3'>
                    <div class='form-group'>
                        <label class="mb-0"for="user_firstname">First Name</label>                      
                        <input type="text"  class="form-control" name="firtName" size="20"
                        placeholder="First Name" 
                        [(ngModel)]="user.firstName" required minlength="2"  #firstNameField="ngModel">
                       <!-- <div size=2 class="mt-0 errorField" [hidden]="firstNameField.valid|| firstNameField.untouched" class="alert alert-danger">
                          Please enter a valid first name.
                         </div>-->
                    </div>
                </div>
                <div class='col-sm-3'>
                    <div class='form-group'>
                        <label class="mb-0"for="user_lastname">Last Name</label>
                        <input class="form-control" type="text" name="lastName" size="20" placeholder="Last Name" 
                        [(ngModel)]="user.lastName" required min="2">
                    </div>
                </div>

                <div class='col-sm-3'>
                    <div class='form-group'>
                        <label class="mb-0"for="username">UserName</label>
                        <input class="form-control" type="text" name="lastName" size="20" placeholder="Last Name" 
                        [(ngModel)]="user.username" required min="2">
                    </div>
                </div>
  
  
               
              <div class='col-sm-3'>
                <div class='form-group'>    
                    <label class="mb-0"for="email">email</label>
                    <input type="text" name="ssn" class="form-control" size="30" placeholder="email"  [(ngModel)]="user.email" required>
                </div>
            </div>
  
            </div>
           
        </fieldset>
  
       
    <div class="container">   
      <div class="row">  
        <div id ="btn-success"class="ml-0 pl-0 col-sm-3">
          <button class="btn  btn-success">Submit</button>        
        </div>      
        <div id ="errorDiv" class="col-sm-9 alert border border-danger alert-danger text-capitalize" [hidden]="!postError">     
           <ul class="heroes">
             <li *ngIf='errorMessage'>  {{errorMessage}}</li>
             <li *ngIf='unhandledError'>   {{unhandledError}}</li>
             <li *ngFor='let err of errorResponse?.errors'>
              <span class="badge">{{err}}</span> 
               </li>          
            </ul>         
        </div>
        <div id ="errorSuccess" class="col-sm-9  border border-success alert alert-success" [hidden]="!postSuccess">     
           User created successfully. 
       </div>
      </div>
    </div>  
  
        
      
       
    </form>
  
  </div>
  